export default __webpack_public_path__ + "static/media/kitchen3-afterK-768w.d34b1bc4.avif";